import React, { useEffect } from 'react';

const VistaERD = () => {
  useEffect(() => {
    // Initialize drag functionality after component mounts
    const initDrag = () => {
      const entities = document.querySelectorAll('.entity');
      let draggedElement = null;
      let offset = { x: 0, y: 0 };
      let isDragging = false;

      entities.forEach(entity => {
        entity.addEventListener('mousedown', (e) => {
          e.preventDefault();
          draggedElement = entity;
          isDragging = true;
          const rect = entity.getBoundingClientRect();
          offset.x = e.clientX - rect.left;
          offset.y = e.clientY - rect.top;
          entity.classList.add('dragging');
          document.getElementById('erdContainer').classList.add('dragging');
        });
      });

      document.addEventListener('mousemove', (e) => {
        if (!draggedElement || !isDragging) return;
        
        e.preventDefault();
        const containerRect = document.getElementById('erdContainer').getBoundingClientRect();
        const x = e.clientX - containerRect.left - offset.x;
        const y = e.clientY - containerRect.top - offset.y;
        
        const maxX = containerRect.width - draggedElement.offsetWidth;
        const maxY = containerRect.height - draggedElement.offsetHeight;
        
        // Use transform for smoother movement
        const clampedX = Math.max(0, Math.min(x, maxX));
        const clampedY = Math.max(0, Math.min(y, maxY));
        
        draggedElement.style.left = clampedX + 'px';
        draggedElement.style.top = clampedY + 'px';
      });

      document.addEventListener('mouseup', () => {
        if (draggedElement && isDragging) {
          draggedElement.classList.remove('dragging');
          document.getElementById('erdContainer').classList.remove('dragging');
          isDragging = false;
          draggedElement = null;
        }
      });

      // Highlight corrected fields on hover
      const correctedFields = document.querySelectorAll('.field.corrected');
      correctedFields.forEach(field => {
        field.addEventListener('mouseenter', () => {
          field.style.transform = 'scale(1.05)';
          field.style.fontWeight = 'bold';
        });
        
        field.addEventListener('mouseleave', () => {
          field.style.transform = '';
          field.style.fontWeight = '';
        });
      });

              // Add click functionality to show table relationships
        entities.forEach(entity => {
          entity.addEventListener('click', () => {
            const tableName = entity.querySelector('.entity-header').textContent;
            console.log(`Clicked on: ${tableName}`);
          });
        });
      };

      // Wait for the HTML to be rendered
      setTimeout(initDrag, 100);
    }, []);

    // Add tab switching functionality
    const showSection = (sectionName, event) => {
      // Hide all sections
      const sections = document.querySelectorAll('.section');
      sections.forEach(section => section.classList.remove('active'));
      
      // Remove active from all tabs
      const tabs = document.querySelectorAll('.tab');
      tabs.forEach(tab => tab.classList.remove('active'));
      
      // Show selected section
      document.getElementById(sectionName).classList.add('active');
      
      // Activate selected tab
      if (event && event.target) {
        event.target.classList.add('active');
      }
    };

    // Initialize tab functionality
    const initTabs = () => {
      const tabs = document.querySelectorAll('.tab');
      tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
          const sectionName = event.target.getAttribute('data-section');
          if (sectionName) {
            showSection(sectionName, event);
          }
        });
      });
    };

    // Initialize tabs after HTML is rendered
    setTimeout(initTabs, 100);

  return (
    <div 
      className="w-full h-full overflow-auto"
      dangerouslySetInnerHTML={{
        __html: `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Viewpoint Vista Database ERD</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 0;
            padding: 0;
            background: #f9fafb;
            min-height: 100vh;
        }

        .container {
            width: 100%;
            height: 100%;
            background: #ffffff;
            border-radius: 8px;
            padding: 24px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }

        h1 {
            text-align: center;
            color: #111827;
            margin-bottom: 24px;
            font-size: 1.875rem;
            font-weight: 600;
        }

        .section-tabs {
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
            border-bottom: 2px solid #e9ecef;
        }

        .tab {
            padding: 15px 25px;
            cursor: pointer;
            border: none;
            background: none;
            font-size: 16px;
            font-weight: 600;
            color: #6c757d;
            border-bottom: 3px solid transparent;
            transition: all 0.3s ease;
        }

        .tab.active {
            color: #495057;
            border-bottom-color: #007bff;
            background: rgba(0, 123, 255, 0.1);
        }

        .tab:hover {
            background: rgba(0, 123, 255, 0.05);
        }

        .section {
            display: none;
            animation: fadeIn 0.5s ease-in;
        }

        .section.active {
            display: block;
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }

        .erd-container {
            position: relative;
            width: 100%;
            flex: 1;
            background: #f8f9fa;
            border-radius: 15px;
            border: 2px solid #e9ecef;
            overflow: hidden;
            box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.05);
            min-width: 1200px;
        }

        .entity {
            position: absolute;
            background: white;
            border: 2px solid #343a40;
            border-radius: 12px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            cursor: move;
            min-width: 200px;
            will-change: transform;
        }

        .entity:hover {
            transform: translateY(-3px);
            box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
        }
        
        .entity.dragging {
            transition: none;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
            transform: scale(1.02);
            z-index: 1000;
            user-select: none;
        }
        
        .erd-container.dragging {
            cursor: grabbing;
        }

        .entity-header {
            background: #343a40;
            color: white;
            padding: 8px 10px;
            font-weight: bold;
            font-size: 11px;
            border-radius: 10px 10px 0 0;
            text-align: center;
        }

        .entity-body {
            padding: 10px;
            font-size: 9px;
            line-height: 1.3;
        }

        .field {
            margin: 1px 0;
            padding: 0;
        }

        .field.primary-key {
            font-weight: bold;
            color: #dc3545;
        }

        .field.foreign-key {
            color: #007bff;
        }

        .field.corrected {
            background: #d4edda;
            padding: 2px 4px;
            border-radius: 3px;
            border-left: 3px solid #28a745;
        }

        /* Entity positioning and colors */
        .job-cost { background: linear-gradient(135deg, #e8f5e8, #c8e6c9); }
        .job-cost .entity-header { background: linear-gradient(135deg, #388e3c, #2e7d32); }

        .payroll { background: linear-gradient(135deg, #fff3e0, #ffe0b2); }
        .payroll .entity-header { background: linear-gradient(135deg, #f57c00, #ef6c00); }

        .ap { background: linear-gradient(135deg, #fce4ec, #f8bbd9); }
        .ap .entity-header { background: linear-gradient(135deg, #c2185b, #ad1457); }

        .ar { background: linear-gradient(135deg, #f3e5f5, #e1bee7); }
        .ar .entity-header { background: linear-gradient(135deg, #7b1fa2, #6a1b9a); }

        .gl { background: linear-gradient(135deg, #e0f2f1, #b2dfdb); }
        .gl .entity-header { background: linear-gradient(135deg, #00695c, #004d40); }

        .po { background: linear-gradient(135deg, #e8eaf6, #c5cae9); }
        .po .entity-header { background: linear-gradient(135deg, #3f51b5, #303f9f); }

        .subcontract { background: linear-gradient(135deg, #e0f7fa, #b2ebf2); }
        .subcontract .entity-header { background: linear-gradient(135deg, #0097a7, #00838f); }

        .volume-indicator {
            position: absolute;
            top: -8px;
            right: -8px;
            background: #dc3545;
            color: white;
            border-radius: 50%;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 9px;
            font-weight: bold;
        }

        .volume-high { background: #dc3545; }
        .volume-medium { background: #ffc107; color: #000; }
        .volume-low { background: #28a745; }

        .legend {
            position: absolute;
            top: 20px;
            right: 20px;
            background: rgba(255, 255, 255, 0.95);
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            font-size: 12px;
            max-width: 250px;
        }

        .legend-item {
            display: flex;
            align-items: center;
            margin: 8px 0;
        }

        .legend-color {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            margin-right: 10px;
        }

        .relationship-line {
            position: absolute;
            height: 2px;
            background: #6c757d;
            transform-origin: left center;
            pointer-events: none;
        }

        .relationship-line::after {
            content: '';
            position: absolute;
            right: -8px;
            top: -3px;
            width: 0;
            height: 0;
            border-left: 8px solid #6c757d;
            border-top: 3px solid transparent;
            border-bottom: 3px solid transparent;
        }

        /* Heatmap Styles */
        .heatmap-container {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 20px;
            padding: 20px;
            flex: 1;
            overflow-y: auto;
        }

        .heatmap-category {
            background: white;
            border-radius: 15px;
            padding: 20px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }

        .heatmap-category h3 {
            margin: 0 0 15px 0;
            color: #495057;
            border-bottom: 2px solid #e9ecef;
            padding-bottom: 10px;
        }

        .heatmap-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            margin: 5px 0;
            border-radius: 8px;
            font-size: 14px;
        }

        .heatmap-high { background: linear-gradient(135deg, #ff5722, #f44336); color: white; }
        .heatmap-medium { background: linear-gradient(135deg, #ff9800, #ffc107); color: #333; }
        .heatmap-low { background: linear-gradient(135deg, #4caf50, #8bc34a); color: white; }

        /* Relationship Matrix Styles */
        .relationship-container {
            background: white;
            border-radius: 15px;
            padding: 30px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
            flex: 1;
            overflow-y: auto;
        }

        .relationship-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
            gap: 25px;
            margin-top: 20px;
        }

        .relationship-card {
            background: #f8f9fa;
            border-radius: 12px;
            padding: 20px;
            border-left: 5px solid #007bff;
        }

        .relationship-card h4 {
            margin: 0 0 15px 0;
            color: #495057;
        }

        .relationship-item {
            background: white;
            padding: 8px 12px;
            margin: 5px 0;
            border-radius: 6px;
            font-family: 'Courier New', monospace;
            font-size: 12px;
            border-left: 3px solid #28a745;
        }

        /* Workflow Styles */
        .workflow-container {
            background: white;
            border-radius: 15px;
            padding: 30px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
            flex: 1;
            overflow-y: auto;
        }

        .workflow-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
            gap: 30px;
            margin-top: 20px;
        }

        .workflow-card {
            background: #f8f9fa;
            border-radius: 12px;
            padding: 25px;
            border-top: 5px solid #6f42c1;
        }

        .workflow-card h4 {
            margin: 0 0 20px 0;
            color: #495057;
            font-size: 18px;
        }

        .workflow-step {
            display: flex;
            align-items: center;
            margin: 15px 0;
            padding: 12px;
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .workflow-step-number {
            background: #6f42c1;
            color: white;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            margin-right: 15px;
        }

        .workflow-arrow {
            text-align: center;
            color: #6c757d;
            font-size: 20px;
            margin: 5px 0;
        }

        @media (max-width: 1200px) {
            .container { padding: 15px; }
            .erd-container { height: 800px; }
            .legend { position: relative; margin-top: 20px; }
        }
    </style>
</head>
<body>
    <div class="container">
        <h1>Viewpoint Vista Database - Complete Analysis</h1>
        
                    <div class="section-tabs">
                <button class="tab active" data-section="erd">Entity Relationship Diagram</button>
                <button class="tab" data-section="heatmap">Data Volume Heatmap</button>
                <button class="tab" data-section="relationships">Table Relationships</button>
                <button class="tab" data-section="workflows">Business Workflows</button>
            </div>

        <!-- ERD Section -->
        <div id="erd" class="section active">
            <div class="erd-container" id="erdContainer">
            <!-- ===== ROW 1: PURCHASE ORDERS & GENERAL LEDGER ===== -->
            <div class="entity po" style="top: 30px; left: 30px; width: 180px;">
                <div class="entity-header">bPOHD (PO Headers)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 POCo + PO (PK)</div>
                    <div class="field foreign-key">👤 Vendor (FK)</div>
                    <div class="field">Description</div>
                    <div class="field">OrderDate</div>
                    <div class="field">Status</div>
                </div>
                <div class="volume-indicator volume-low">37K</div>
            </div>

            <div class="entity po" style="top: 30px; left: 230px; width: 180px;">
                <div class="entity-header">bPOIT (PO Items)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 POCo + PO (PK)</div>
                    <div class="field foreign-key">📦 Material (FK)</div>
                    <div class="field">Description</div>
                    <div class="field">UM</div>
                </div>
                <div class="volume-indicator volume-medium">101K</div>
            </div>

            <div class="entity gl" style="top: 30px; left: 430px; width: 180px;">
                <div class="entity-header">bGLAC (GL Accounts)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 GLCo + GLAcct (PK)</div>
                    <div class="field">Description</div>
                    <div class="field">AcctType</div>
                    <div class="field">Active</div>
                </div>
                <div class="volume-indicator volume-low">4K</div>
            </div>

            <div class="entity gl" style="top: 30px; left: 630px; width: 180px;">
                <div class="entity-header">bGLDT (GL Transactions)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 GLCo + GLAcct + ActDate (PK)</div>
                    <div class="field">Description</div>
                    <div class="field">Amount</div>
                </div>
                <div class="volume-indicator volume-medium">953K</div>
            </div>

            <div class="entity gl" style="top: 30px; left: 830px; width: 180px;">
                <div class="entity-header">bGLBD (GL Budget)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 GLCo + GLAcct + Mth (PK)</div>
                    <div class="field">BudgetAmt</div>
                </div>
            </div>

            <!-- ===== ROW 2: JOB COST ===== -->
            <div class="entity job-cost" style="top: 200px; left: 30px; width: 180px;">
                <div class="entity-header">bJCJM (Job Master)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 JCCo + Job (PK)</div>
                    <div class="field">Description</div>
                    <div class="field foreign-key">📄 Contract (FK)</div>
                    <div class="field">JobStatus</div>
                    <div class="field">BidNumber</div>
                    <div class="field foreign-key">👤 ProjectMgr (FK)</div>
                    <div class="field">TaxGroup / TaxCode</div>
                </div>
                <div class="volume-indicator volume-low">2K</div>
            </div>

            <div class="entity job-cost" style="top: 200px; left: 230px; width: 180px;">
                <div class="entity-header">bJCCD (Job Cost Detail)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 JCCo + Job + Phase + CostType (PK)</div>
                    <div class="field">ActualDate</div>
                    <div class="field">Description</div>
                    <div class="field">ActualCost</div>
                    <div class="field">EstCost</div>
                    <div class="field">ProjCost</div>
                    <div class="field">ForecastCost</div>
                    <div class="field">ProgressCmplt</div>
                    <div class="field">ACO / ACOItem</div>
                </div>
                <div class="volume-indicator volume-high">10M</div>
            </div>

            <div class="entity job-cost" style="top: 200px; left: 430px; width: 180px;">
                <div class="entity-header">bJCID (Job Contract Items)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 JCCo + Contract + Item (PK)</div>
                    <div class="field">ActualDate</div>
                    <div class="field">ContractAmt</div>
                    <div class="field">BilledAmt</div>
                    <div class="field">ReceivedAmt</div>
                    <div class="field">ACO / ACOItem</div>
                </div>
            </div>

            <!-- ===== ROW 3: PAYROLL ===== -->
            <div class="entity payroll" style="top: 370px; left: 30px; width: 180px;">
                <div class="entity-header">bPRTL (Timecard Lines)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 PRCo + PREndDate + Employee + PaySeq + PostSeq (PK)</div>
                    <div class="field">PRGroup</div>
                    <div class="field foreign-key">👤 Employee (FK)</div>
                    <div class="field">LiabCode</div>
                    <div class="field">Rate</div>
                    <div class="field">Amt</div>
                </div>
                <div class="volume-indicator volume-high">18.6M</div>
            </div>

            <div class="entity payroll" style="top: 370px; left: 230px; width: 180px;">
                <div class="entity-header">bPRJC (Payroll Job Cost)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 PRCo + PREndDate + Employee (PK)</div>
                    <div class="field foreign-key">🏗️ Job + Phase (FK)</div>
                    <div class="field">JCCostType</div>
                    <div class="field">Craft / Factor</div>
                    <div class="field">Hrs</div>
                    <div class="field">Amt</div>
                </div>
                <div class="volume-indicator volume-high">9.6M</div>
            </div>

            <div class="entity payroll" style="top: 370px; left: 430px; width: 180px;">
                <div class="entity-header">bPRPH (Payment Header)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 PRCo + Employee + PREndDate (PK)</div>
                    <div class="field">PayMethod</div>
                    <div class="field">Hours / Earnings</div>
                    <div class="field">PaidAmt</div>
                </div>
                <div class="volume-indicator volume-medium">290K</div>
            </div>

            <!-- ===== ROW 4: ACCOUNTS PAYABLE ===== -->
            <div class="entity ap" style="top: 540px; left: 30px; width: 180px;">
                <div class="entity-header">bAPVM (Vendor Master)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 VendorGroup + Vendor (PK)</div>
                    <div class="field">Name</div>
                    <div class="field">Contact</div>
                    <div class="field">Phone / EMail</div>
                </div>
                <div class="volume-indicator volume-low">9K</div>
            </div>

            <div class="entity ap" style="top: 540px; left: 230px; width: 180px;">
                <div class="entity-header">bAPTH (AP Headers)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 APCo + Vendor + APRef (PK)</div>
                    <div class="field">Description</div>
                    <div class="field">InvDate / DueDate</div>
                    <div class="field">InvTotal</div>
                    <div class="field">OpenYN</div>
                </div>
                <div class="volume-indicator volume-medium">247K</div>
            </div>

            <div class="entity ap" style="top: 540px; left: 430px; width: 180px;">
                <div class="entity-header">bAPTD (AP Detail)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 APCo + APTrans + APLine (PK)</div>
                    <div class="field">Amount</div>
                    <div class="field">DueDate / Status</div>
                    <div class="field foreign-key">🏗️ Job + Phase (FK)</div>
                    <div class="field">CostType</div>
                </div>
                <div class="volume-indicator volume-medium">349K</div>
            </div>

            <!-- ===== ROW 5: ACCOUNTS RECEIVABLE & SUBCONTRACT ===== -->
            <div class="entity ar" style="top: 540px; left: 630px; width: 180px;">
                <div class="entity-header">bARTH (AR Headers)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 ARCo + Customer (PK)</div>
                    <div class="field">CustRef / CustPO</div>
                    <div class="field foreign-key">🏗️ JCCo (FK)</div>
                </div>
                <div class="volume-indicator volume-low">39K</div>
            </div>

            <div class="entity ar" style="top: 540px; left: 830px; width: 180px;">
                <div class="entity-header">bARTL (AR Lines)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 ARCo + ARTrans + ARLine (PK)</div>
                    <div class="field">Description</div>
                    <div class="field foreign-key">📊 GLAcct (FK)</div>
                </div>
                <div class="volume-indicator volume-medium">99K</div>
            </div>

            <div class="entity ar" style="top: 540px; left: 1030px; width: 180px;">
                <div class="entity-header">bARMT (Customer Master)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 ARCo + Customer (PK)</div>
                    <div class="field">Invoiced</div>
                    <div class="field">Retainage</div>
                    <div class="field">Paid</div>
                </div>
                <div class="volume-indicator volume-low">10K</div>
            </div>

            <div class="entity subcontract" style="top: 710px; left: 30px; width: 180px;">
                <div class="entity-header">bSLHD (Subcontract Headers)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 SLCo + SL (PK)</div>
                    <div class="field foreign-key">🏗️ Job (FK)</div>
                    <div class="field">Description</div>
                    <div class="field foreign-key">👤 Vendor (FK)</div>
                </div>
                <div class="volume-indicator volume-low">2K</div>
            </div>

            <div class="entity subcontract" style="top: 710px; left: 230px; width: 180px;">
                <div class="entity-header">bSLIT (Subcontract Items)</div>
                <div class="entity-body">
                    <div class="field primary-key">🔑 SLCo + SL (PK)</div>
                    <div class="field foreign-key">🏗️ Job + Phase (FK)</div>
                </div>
                <div class="volume-indicator volume-low">3K</div>
            </div>






        </div>

        <div class="legend">
            <h3 style="margin-top: 0;">Legend</h3>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #388e3c, #2e7d32);"></div>
                <span>Job Cost</span>
            </div>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #f57c00, #ef6c00);"></div>
                <span>Payroll</span>
            </div>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #c2185b, #ad1457);"></div>
                <span>Accounts Payable</span>
            </div>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #7b1fa2, #6a1b9a);"></div>
                <span>Accounts Receivable</span>
            </div>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #00695c, #004d40);"></div>
                <span>General Ledger</span>
            </div>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #3f51b5, #303f9f);"></div>
                <span>Purchase Orders</span>
            </div>
            <div class="legend-item">
                <div class="legend-color" style="background: linear-gradient(135deg, #0097a7, #00838f);"></div>
                <span>Subcontract</span>
            </div>
            <hr>
            <div style="font-size: 11px; margin-top: 10px;">
                <div><strong>🔑</strong> Primary Key</div>
                <div><strong>FK</strong> Foreign Key</div>

                <div><strong>Volume:</strong></div>
                <div style="margin-left: 10px;">
                    <span style="color: #dc3545;">●</span> High (&gt;1M)<br>
                    <span style="color: #ffc107;">●</span> Medium (100K-1M)<br>
                    <span style="color: #28a745;">●</span> Low (&lt;100K)
                </div>
            </div>
        </div>
        </div>

        <!-- Heatmap Section -->
        <div id="heatmap" class="section">
            <div class="heatmap-container">
                <div class="heatmap-category">
                    <h3>🔥 High Volume Tables (>1M rows)</h3>
                    <div class="heatmap-item heatmap-high">
                        <span><strong>bHQMA</strong> - Audit Master</span>
                        <span>24.4M rows</span>
                    </div>
                    <div class="heatmap-item heatmap-high">
                        <span><strong>bPRTL</strong> - Timecard Lines</span>
                        <span>18.6M rows</span>
                    </div>
                    <div class="heatmap-item heatmap-high">
                        <span><strong>bJCCD</strong> - Job Cost Detail</span>
                        <span>10.0M rows</span>
                    </div>
                    <div class="heatmap-item heatmap-high">
                        <span><strong>bPRJC</strong> - Payroll Job Cost</span>
                        <span>9.6M rows</span>
                    </div>
                </div>

                <div class="heatmap-category">
                    <h3>⚡ Medium Volume Tables (100K-1M rows)</h3>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bGLDT</strong> - GL Transactions</span>
                        <span>953K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bAPTD</strong> - AP Details</span>
                        <span>349K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bJBIS</strong> - Job Billing Summary</span>
                        <span>308K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bJBIT</strong> - Job Billing Items</span>
                        <span>303K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bPRPH</strong> - Payroll Payments</span>
                        <span>290K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bAPTH</strong> - AP Headers</span>
                        <span>247K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bPOIT</strong> - PO Items</span>
                        <span>101K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-medium">
                        <span><strong>bARTL</strong> - AR Lines</span>
                        <span>99K rows</span>
                    </div>
                </div>

                <div class="heatmap-category">
                    <h3>💚 Low Volume Tables (<100K rows)</h3>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bARTH</strong> - AR Headers</span>
                        <span>39K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bPOHD</strong> - PO Headers</span>
                        <span>37K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bARMT</strong> - Customer Master</span>
                        <span>9.5K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bAPVM</strong> - Vendor Master</span>
                        <span>8.6K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bJBCX</strong> - Billing CO Items</span>
                        <span>5.5K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bJBCC</strong> - Billing Change Orders</span>
                        <span>4.1K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bGLAC</strong> - GL Accounts</span>
                        <span>3.6K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bSLIT</strong> - Subcontract Items</span>
                        <span>2.9K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bJCJM</strong> - Job Master</span>
                        <span>2.1K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bSLHD</strong> - Subcontract Headers</span>
                        <span>1.6K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bHQMT</strong> - Materials</span>
                        <span>1.1K rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bEMEM</strong> - Equipment</span>
                        <span>52 rows</span>
                    </div>
                    <div class="heatmap-item heatmap-low">
                        <span><strong>bJBID</strong> - Billing Detail</span>
                        <span>0 rows</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Relationships Section -->
        <div id="relationships" class="section">
            <div class="relationship-container">
                <h2>Table Relationships Matrix</h2>
                <div class="relationship-grid">
                    <div class="relationship-card">
                        <h4>🏗️ Job Cost Relationships</h4>
                        <div class="relationship-item">bJCJM.JCCo = bJCCD.JCCo AND bJCJM.Job = bJCCD.Job</div>
                        <div class="relationship-item">bJCJM.JCCo = bPRJC.JCCo AND bJCJM.Job = bPRJC.Job</div>
                        <div class="relationship-item">bJCID.JCCo = bJCCD.JCCo AND bJCID.Mth = bJCCD.Mth</div>
                        <div class="relationship-item">bEMEM.EMCo = bJCCD.EMCo AND bEMEM.JCCo = bJCCD.JCCo</div>
                    </div>

                    <div class="relationship-card">
                        <h4>🔗 Job Foreign Key Relationships</h4>
                        <div class="relationship-item">bJCJM.Job = bPOHD.Job (Purchase Order Headers)</div>
                        <div class="relationship-item">bJCJM.Job = bPOIT.Job (Purchase Order Items)</div>
                        <div class="relationship-item">bJCJM.Job = bARTL.Job (Invoice Lines)</div>
                        <div class="relationship-item">bJCJM.Job = bSLHD.Job (Subcontract Headers)</div>
                        <div class="relationship-item">bJCJM.Job = bPRJC.Job (Payroll Job Cost)</div>
                        <div class="relationship-item">bJCJM.Job = bJCCD.Job (Job Cost Detail)</div>
                    </div>



                    <div class="relationship-card">
                        <h4>💰 Payroll Relationships</h4>
                        <div class="relationship-item">bPRTL.PRCo = bPRJC.PRCo</div>
                        <div class="relationship-item">bPRTL.Employee = bPRJC.Employee</div>
                        <div class="relationship-item">bPRTL.PREndDate = bPRJC.PREndDate</div>
                        <div class="relationship-item">bPRTL.PRGroup = bPRJC.PRGroup</div>
                        <div class="relationship-item">bPRTL.PaySeq = bPRJC.PaySeq</div>
                        <div class="relationship-item">bPRTL → bPRPH (same key structure)</div>
                    </div>

                    <div class="relationship-card">
                        <h4>📄 AP Relationships</h4>
                        <div class="relationship-item">bAPVM.Vendor = bAPTH.Vendor</div>
                        <div class="relationship-item">bAPVM.VendorGroup = bAPTH.VendorGroup</div>
                        <div class="relationship-item">bAPTH.APCo = bAPTD.APCo</div>
                        <div class="relationship-item">bAPTH.APTrans = bAPTD.APTrans</div>
                        <div class="relationship-item">bAPVM → bPOHD (Vendor relationships)</div>
                        <div class="relationship-item">bAPVM → bSLHD (Vendor relationships)</div>
                    </div>

                    <div class="relationship-card">
                        <h4>💳 AR Relationships</h4>
                        <div class="relationship-item">bARMT.ARCo = bARTH.ARCo</div>
                        <div class="relationship-item">bARMT.CustGroup = bARTH.CustGroup</div>
                        <div class="relationship-item">bARMT.Customer = bARTH.Customer</div>
                        <div class="relationship-item">bARTH.ARCo = bARTL.ARCo</div>
                        <div class="relationship-item">bARTH.ARTrans = bARTL.ARTrans</div>
                    </div>

                    <div class="relationship-card">
                        <h4>📊 GL Relationships</h4>
                        <div class="relationship-item">bGLAC.GLCo = bGLDT.GLCo</div>
                        <div class="relationship-item">bGLAC.GLAcct = bGLDT.GLAcct</div>
                        <div class="relationship-item">bGLAC.GLCo = bGLBD.GLCo</div>
                        <div class="relationship-item">bGLAC.GLAcct = bGLBD.GLAcct</div>
                    </div>

                    <div class="relationship-card">
                        <h4>🛍️ PO Relationships</h4>
                        <div class="relationship-item">bPOHD.POCo = bPOIT.POCo</div>
                        <div class="relationship-item">bPOHD.PO = bPOIT.PO</div>
                        <div class="relationship-item">bHQMT.Material = bPOIT.Material</div>
                        <div class="relationship-item">bHQMT.MatlGroup = bPOIT.MatlGroup</div>
                    </div>

                    <div class="relationship-card">
                        <h4>🔧 Subcontract Relationships</h4>
                        <div class="relationship-item">bSLHD.SLCo = bSLIT.SLCo</div>
                        <div class="relationship-item">bSLHD.SL = bSLIT.SL</div>
                    </div>

                    <div class="relationship-card">
                        <h4>💼 Job Billing Relationships</h4>
                        <div class="relationship-item">bJBIS.JBCo = bJBIT.JBCo</div>
                        <div class="relationship-item">bJBIS.BillNumber = bJBIT.BillNumber</div>
                        <div class="relationship-item">bJBIS → bJBCC (Change Orders)</div>
                        <div class="relationship-item">bJBCC → bJBCX (Change Order Items)</div>
                        <div class="relationship-item">bJBIS → bJBID (Billing Detail)</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Workflows Section -->
        <div id="workflows" class="section">
            <div class="workflow-container">
                <h2>Business Process Workflows</h2>
                <div class="workflow-grid">
                    <div class="workflow-card">
                        <h4>🏗️ Job Cost Management Process</h4>
                        <div class="workflow-step">
                            <div class="workflow-step-number">1</div>
                            <div>
                                <strong>Job Creation</strong><br>
                                Create job in bJCJM with contract, status, project manager
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">2</div>
                            <div>
                                <strong>Phase Setup</strong><br>
                                Setup phases and cost types in bJCCD with EstCost budgets
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">3</div>
                            <div>
                                <strong>Time Allocation</strong><br>
                                bPRTL → bPRJC → bJCCD.ActualCost (time costs)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">4</div>
                            <div>
                                <strong>Expense Allocation</strong><br>
                                bAPTD → bJCCD.ActualCost (material/vendor costs)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">5</div>
                            <div>
                                <strong>Financial Posting</strong><br>
                                bJCCD → bGLDT (post to general ledger)
                            </div>
                        </div>
                    </div>

                    <div class="workflow-card">
                        <h4>💰 Payroll to Job Cost Process</h4>
                        <div class="workflow-step">
                            <div class="workflow-step-number">1</div>
                            <div>
                                <strong>Time Entry</strong><br>
                                Employees enter time in bPRTL (Rate × Amt)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">2</div>
                            <div>
                                <strong>Job Allocation</strong><br>
                                Time allocated to jobs in bPRJC (Hrs × Amt by Job/Phase)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">3</div>
                            <div>
                                <strong>Cost Recording</strong><br>
                                Job costs recorded in bJCCD.ActualCost
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">4</div>
                            <div>
                                <strong>Payment Processing</strong><br>
                                Employee payments in bPRPH (Hours/Earnings/PaidAmt)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">5</div>
                            <div>
                                <strong>GL Posting</strong><br>
                                Payroll costs posted to bGLDT
                            </div>
                        </div>
                    </div>

                    <div class="workflow-card">
                        <h4>🛍️ Purchase-to-Pay Process</h4>
                        <div class="workflow-step">
                            <div class="workflow-step-number">1</div>
                            <div>
                                <strong>Purchase Order</strong><br>
                                Create PO in bPOHD with vendor from bAPVM
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">2</div>
                            <div>
                                <strong>PO Items</strong><br>
                                Add materials in bPOIT from bHQMT catalog
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">3</div>
                            <div>
                                <strong>Invoice Receipt</strong><br>
                                Vendor invoice in bAPTH with details in bAPTD
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">4</div>
                            <div>
                                <strong>Job Cost Allocation</strong><br>
                                bAPTD costs allocated to bJCCD by Job/Phase
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">5</div>
                            <div>
                                <strong>Payment & GL</strong><br>
                                Payment processed and posted to bGLDT
                            </div>
                        </div>
                    </div>

                    <div class="workflow-card">
                        <h4>💼 Job Billing Process</h4>
                        <div class="workflow-step">
                            <div class="workflow-step-number">1</div>
                            <div>
                                <strong>Billing Summary</strong><br>
                                Create billing summary in bJBIS (Job/Item/AmtBilled)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">2</div>
                            <div>
                                <strong>Billing Items</strong><br>
                                Detail billing items in bJBIT (UnitsBilled/AmtBilled)
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">3</div>
                            <div>
                                <strong>Change Orders</strong><br>
                                Process change orders in bJBCC → bJBCX
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">4</div>
                            <div>
                                <strong>Invoice Generation</strong><br>
                                Generate customer invoice in bARTH/bARTL
                            </div>
                        </div>
                        <div class="workflow-arrow">⬇️</div>
                        <div class="workflow-step">
                            <div class="workflow-step-number">5</div>
                            <div>
                                <strong>Revenue Recognition</strong><br>
                                Post revenue to bGLDT and update bJCID receivables
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
</html>
        `
      }}
    />
  );
};

export default VistaERD; 